import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return null
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.any,
  title: PropTypes.string
}

export default Breadcrumb
